/* eslint-disable react-refresh/only-export-components */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { notification, message as antdMessage } from "antd";
import WarningIcon from "../../assets/icons/warning-icon.svg";
import closeIcon from "../../assets/icons/closeIcon.svg";

interface ToastNotifyProps {
  type: "success" | "info" | "warning" | "error";
  message: string;
  description?: string;
  onClose?:()=>void;
  duration?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
}

const ToastNotify: React.FC<ToastNotifyProps> = ({
  type,
  message,
  description,
  onClose,
}) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    api[type]({
      message: message,
      description: description,
    });
  }, [type, message, description,onClose]);

  return <>{contextHolder}</>;
};

// for non react component notification
export const customNotify = ({
  message,
  description,
  type,
  duration,
  style,
  onClose,
}: ToastNotifyProps) => {
  const params = { message: message, description: description,  duration: duration || 3,onClose:onClose,style: style};

  if (type == "success") {
    notification.success(params);
  }
  if (type == "info") {
    notification.info(params);
  }
  if (type == "warning") {
    notification.warning(params);
  }
  if (type == "error") {
    notification.error(params);
  }
};

export const toastMessage = ({
  message,
  description,
  type,
  duration,
  style,
  onClose,
}: ToastNotifyProps) => {
  antdMessage.config({
            rtl: false,
          });
  
  const params = { content: message, description: description,  duration: duration ?? 0,onClose:onClose,style: style};
  if (type == "success") {
    antdMessage.success(params);
  }
  if (type == "info") {
    antdMessage.info(params);
  }
  if (type == "warning") {
    antdMessage.warning({ icon: <img src={WarningIcon} className="icon" />,...params, content: <div className="content">
      <img src={closeIcon} onClick={ ()=> {
        antdMessage.destroy();
      }} alt="" className="close-icon" />
      <span>{message}</span>
    </div>, className: "grn-toast-message" });
  }
  if (type == "error") {
    antdMessage.error(params);
  }
}

export default ToastNotify;
